import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";
import {Request} from "../classes/request";

@Injectable({
    providedIn: 'root'
})
export class GoogleDriveService {
    API_GOOGLE_DRIVE_URL = config.serverAddress + ':' + config.serverPort + '/google-drive/';

    constructor(private http: HttpClient) { }

    createFolder(idFolderParent: string | null, nameFolder: string, idRequestType: number) {
        return this.http.post(this.API_GOOGLE_DRIVE_URL + 'create-folder', {
            IDFolderParent: idFolderParent,
            NameFolder: nameFolder,
            IDRequestType: idRequestType
        });
    }
}
